module.exports = __webpack_public_path__ + "static/media/standard-config-placeholder.4639515a.svg";